import HeroAdvisory from "components/PropertyAdvisory/HeroAdvisory";
import ListAdvisory from "components/PropertyAdvisory/ListAdvisory";
import MissionAdvisory from "components/PropertyAdvisory/MissionAdvisory";
import QuoteAdvisory from "components/PropertyAdvisory/QuoteAdvisory";
import PriceSection from "components/Service/PriceSection";
import React from "react";

const PropertyAdvisory = () => {
  return (
    <div>
      <HeroAdvisory />
      <QuoteAdvisory />
      <MissionAdvisory />
      <ListAdvisory />
      <PriceSection />
    </div>
  );
};

export default PropertyAdvisory;
